import React from 'react';
import { UserVerificationManager } from '@edreamsodigeo/frontend-user-authentication';
import { getOdigeoSessionValue } from '../../../boundaries/flow/getOdigeoSessionValue';
const UserVerificationManagerWrapper = () => {
  const isMeta = getOdigeoSessionValue('isMeta', false);
  return /*#__PURE__*/React.createElement(UserVerificationManager, {
    isMeta: isMeta
  });
};
export default UserVerificationManagerWrapper;